document.addEventListener('DOMContentLoaded',function(){
  /* (1) Avis Sophie -> section avis */
  var ri=document.querySelector('.products-grid .review-inline');
  var grid=document.querySelector('.reviews-grid');
  if(ri&&grid){
    var c=document.createElement('div');
    c.className='review-card';
    c.innerHTML=`<div class='rev-top'><div class='rev-avatar'>S</div><div><div class='rev-name'>Sophie M.</div><div class='rev-date'>Il y a 3 jours</div></div></div><div class='rev-stars'>★★★★★</div><p class='rev-text'>« Commandé le ventilateur de cou pour les vacances — jamais je ne repars sans lui. Silencieux, léger, et il tient toute la journée. »</p><div class='rev-verified'>✓ Achat vérifié</div>`;
    grid.insertBefore(c,grid.firstChild);
    ri.remove();
  }
  /* (4) Livraison Gratuite -> bandeau pleine largeur */
  var sc=document.querySelector('.products-grid .shipping-card');
  var ps=document.querySelector('.products-section');
  if(sc&&ps){
    var b=document.createElement('div');
    b.className='shipping-banner';
    b.innerHTML=`<div class='sb-inner'><div class='sb-icon'>🚚</div><div><div class='sb-title'>Livraison Gratuite</div><p class='sb-text'>Sur toutes les commandes dès 35 €</p></div></div>`;
    ps.parentNode.insertBefore(b,ps.nextSibling);
    sc.remove();
  }
  /* (Pages) Corriger les liens du pied de page d'accueil vers les vraies pages */
  document.querySelectorAll('footer a[href="/pages/livraison"]').forEach(function(a){a.href='/pages/politique-dexpedition';});
  document.querySelectorAll('footer a[href="/pages/cgv"]').forEach(function(a){a.href='/pages/conditions-generales-de-vente';});
});
